<template>
  <div
    class="wt2-search-component"
    :class="{ '-idle': isIdle, '-focus': isFocus, '-hover': isHover }"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <input
      type="text"
      maxlength="1024"
      :id="guid"
      :value="query"
      :disabled="disabled"
      ref="input"
      @input="onInput"
      @keyup.enter="onEnter"
      @focus="onFocus"
      @blur="onBlur"
    />
    <div class="-curtains">
      <div class="-favicon">
        <i class="wticon wticon-magnifier"></i>
      </div>
      <div class="-placeholder" v-show="showPlaceholder">
        {{ placeholderText }}
      </div>
      <div class="-reset" v-show="showReset" @mousedown="onReset">
        <i class="wticon wticon-close"></i>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholderText: {
      type: String,
      required: false,
      default: 'Search\u2026', // 2026 HORIZONTAL ELLIPSIS
    },
  },

  watch: {
    value() {
      this.query = this.value;
    },
    disabled() {
      this.$refs.input.disabled = this.disabled;
    },
  },

  data() {
    return {
      query: '',
      guid: app.guid(),
      isIdle: true,
      isFocus: false,
      isHover: false,
    };
  },

  created() {
    this.query = this.value.normalizeSpace();
  },

  computed: {
    showPlaceholder() {
      return _.isEmpty(this.query);
    },

    showReset() {
      return !_.isEmpty(this.query);
    },
  },

  methods: {
    onInput(e) {
      this.query = e.target.value;
    },

    onEnter() {
      this.$emit('input', this.query);
    },

    onFocus() {
      this.isFocus = true;
      this.isIdle = false;
    },

    onBlur(e) {
      this.isFocus = false;
      this.isIdle = true;
      if (e.target.value !== this.value) {
        this.$emit('input', this.query);
      }
    },

    onMouseEnter() {
      this.isHover = true;
    },

    onMouseLeave() {
      this.isHover = false;
    },

    onReset() {
      const $el = this.$el.querySelector('input');
      this.query = '';
      $el.value = this.query;
      this.$emit('input', this.query);

      setTimeout(() => {
        $el.focus();
      }, 10);
    },
  },
};
</script>
